import { render, staticRenderFns } from "./ProductSalesReport.vue?vue&type=template&id=5dce8b31&scoped=true&"
import script from "./ProductSalesReport.vue?vue&type=script&lang=js&"
export * from "./ProductSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesReport.vue?vue&type=style&index=0&id=5dce8b31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce8b31",
  null
  
)

export default component.exports